import type {
  IIsSameUploadInFlightProps,
  IUploadIdentity,
} from "../types/uploads";

// NOTE: NSAI-5560 — a second upload of a file that is already uploading is
// never something the user wants: both copies race the server's duplicate-
// content guard, and the loser is refused at confirm having already transferred
// in full (a whole recording over someone's mobile data, on mobile). The
// uploader asks this before it starts anything, so the refusal costs nothing.
//
// Deliberately narrower than the chat attachment rule
// (`filterDuplicateAttachments`): that one dedupes a batch against everything
// attached, including finished items. Here a finished upload — DONE, ERROR or
// CANCELLED — must stay re-uploadable, so only what is still moving counts.
export const isSameUploadInFlight = ({
  inFlightUploads,
  candidate,
}: IIsSameUploadInFlightProps): boolean => {
  for (const upload of inFlightUploads) {
    if (isSameFile({ upload, candidate })) {
      return true;
    }
  }

  return false;
};

interface IIsSameFileProps {
  upload: IUploadIdentity;
  candidate: IUploadIdentity;
}

// NOTE: Name AND size, because either alone is wrong here: recordings share
// names constantly ("audio.m4a", "Recording.mp4"), and two unrelated files can
// coincide on byte size.
const isSameFile = ({ upload, candidate }: IIsSameFileProps): boolean =>
  upload.fileName === candidate.fileName &&
  upload.fileSizeBytes === candidate.fileSizeBytes;
